import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Mission from "../components/Mission";
import Impact from "../components/Impact";
import HowItWorks from "../components/HowItWorks";
import Stories from "../components/Stories";
import RequestHelp from "../components/RequestHelp";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <main className="bg-[#F9F7F4] text-[#1C1917]" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Mission />
      <Impact />
      <HowItWorks />
      <Stories />
      <RequestHelp />
      <Contact />
      <Footer />
    </main>
  );
}
